import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const CreditScoreIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 24, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 22 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3.73322 2.74618L7.39939 6.41236C8.23157 5.74664 9.24228 5.31399 10.3555 5.18873V0C7.82032 0.148543 5.51848 1.15805 3.73322 2.74618Z"
        fill="currentColor"
      />
      <path
        d="M2.8218 3.65723C1.09931 5.59348 0 8.13466 0 10.924C0 11.2803 0.288277 11.5685 0.644531 11.5685H4.55469C4.91094 11.5685 5.19922 11.2803 5.19922 10.924C5.19922 9.55705 5.69409 8.31586 6.48798 7.32341L2.8218 3.65723Z"
        fill="currentColor"
      />
      <path
        d="M15.98 5.88508C15.7628 5.69564 15.4481 5.6711 15.2083 5.82656L9.61464 9.39473C8.8675 9.87181 8.42188 10.6844 8.42188 11.5694C8.42188 12.9913 9.57812 14.1475 11 14.1475C11.9995 14.1475 12.9172 13.5621 13.3377 12.6564L16.1392 6.64164C16.2601 6.38232 16.1953 6.07389 15.98 5.88508Z"
        fill="currentColor"
      />
      <path
        d="M19.1782 3.65723L17.2838 5.55163C17.5224 6.06086 17.5537 6.65696 17.3075 7.18522L16.46 9.00473C16.6782 9.6041 16.8008 10.2483 16.8008 10.924C16.8008 11.2803 17.0891 11.5685 17.4453 11.5685H21.3555C21.7117 11.5685 22 11.2803 22 10.924C22 8.13466 20.9007 5.59348 19.1782 3.65723Z"
        fill="currentColor"
      />
      <path
        d="M11.6445 0V5.18873C12.1872 5.24979 12.7042 5.38639 13.1894 5.58486L14.5154 4.73898C15.0466 4.39472 15.6958 4.32085 16.3718 4.64114L18.2668 2.74618C16.4815 1.15805 14.1797 0.148543 11.6445 0Z"
        fill="currentColor"
      />
    </svg>
  )
})

CreditScoreIcon.displayName = 'CreditScoreIcon'
